<template>
    <div class="search-wrapper">
        <span class="alcomet search-close" @click="closeSearch()">H</span>
        <div class="mobile-search-close" @click="closeSearch()">
          <div class="mobile-search-close-inside">
            <span class="mobile-search-close-line"></span>
            <span class="mobile-search-close-line"></span>
          </div>
        </div>
        <div class="search-input-wrapper">
            <input class="search-input" ref="searchInputField" type="text" placeholder="Type here to search" v-model="searchInput" @keyup="search()">
            <span class="search-text text-light" v-if="searchInput.length && (contactResults.length > 0 || productResults > 0)">search results</span>
            <span class="search-text" v-if="searchInput.length && contactResults.length < 1 && productResults.length < 1">no results for "{{searchInput}}"</span>
            <span class="alcomet search-zoom" v-if="!searchInput.length">R</span>
        </div>
        <div class="search-results" v-if="searchInput.length" ref="resultsWrapper">
          <!-- <div class="search-scrollbar" ref="scrollbar">
            <div class="search-scrollline"></div>
            <div class="search-scroll" ref="scroll" :style="{ top: `${scrollPosition}px`}"></div>
          </div> -->
            <!-- PRODUCTS -->
            <!-- <div class="search-scrollable-results" ref="results" :style="{ transform: `translateY(${scrollResults}px)`}"> -->
            <div v-for="(product, index) in productResults" :key="'product' + index" class="search-result" @click="goToProduct(product)">
                <span v-if="product.images[0]" class="search-result-img" :style="{backgroundImage : `url(${product.images[0]})`}"></span>
                <span v-if="!product.images[0]" class="search-result-icon">
                    <span class="alcomet">d</span>
                </span>
                <div>
                    <h6>{{product.name}}</h6>
                    <p>{{(product.description).substr(0, 80) + '...'}}</p>
                </div>
            </div>
            <!-- CONTACTS -->
            <div v-for="(contact, index) in contactResults" :key="'contact' + index" class="search-result" @click="selectProfile(contact)">
                <span v-if="contact.img" class="search-result-img" :style="{backgroundImage : `url(${contact.img})`}"></span>
                <span v-if="!contact.img" class="search-result-icon">
                    <span class="alcomet">a</span>
                </span>
                <div>
                    <h6>{{contact.name}}</h6>
                    <p>{{contact.position}}</p>
                </div>
            </div>
            <!-- </div> -->
        </div>
        <app-profile-modal v-if="selectedProfile" :staffProfile="selectedProfile"></app-profile-modal>
    </div>
</template>

<script>
import Products from "../products/products.json";
import ProfileModal from "../contacts/ProfileModal";
import SalesDepartment from "../contacts/SalesDepartment.json";
import SupplyChains from "../contacts/SupplyChains.json";
import OtherContacts from "../contacts/OtherContacts.json";
export default {
  components: {
    appProfileModal: ProfileModal
  },
  data() {
    return {
      contactsSalesDepartment: SalesDepartment,
      contactsSupplyChains: SupplyChains,
      contactsOtherContacts: OtherContacts,
      products: Products,
      searchInput: "",
      selectedProfile: undefined,
      productResults: [],
      contactResults: []
      // scrollResults: 0,
      // scrollPosition: 0
    };
  },
  methods: {
    searchProducts() {
      this.productResults = this.productResults.concat(
        this.products.filter(o => {
          return this.searchString(o);
        })
      );
    },
    searchContacts() {
      this.contactResults = this.contactResults.concat(
        this.contactsSalesDepartment.filter(o => {
          return this.searchString(o);
        })
      );
      this.contactResults = this.contactResults.concat(
        this.contactsSupplyChains.filter(o => {
          return this.searchString(o);
        })
      );
      this.contactResults = this.contactResults.concat(
        this.contactsOtherContacts.filter(o => {
          return this.searchString(o);
        })
      );
    },
    // Search logic
    searchString(obj) {
      if (obj.name) {
        if (
          obj.name.toLowerCase().includes(this.searchInput.toLowerCase().trim())
        ) {
          return true;
        }
      }
      if (obj.tags) {
        if (
          obj.tags.some(o => {
            return o
              .toLowerCase()
              .includes(this.searchInput.toLowerCase().trim());
          })
        ) {
          return true;
        }
      }
      if (obj.description) {
        if (
          obj.description
            .toLowerCase()
            .includes(this.searchInput.toLowerCase().trim())
        ) {
          return true;
        }
      }
      if (obj.position) {
        if (
          obj.position
            .toLowerCase()
            .includes(this.searchInput.toLowerCase().trim())
        ) {
          return true;
        }
      }
      if (obj.foreignLanguages) {
        if (
          obj.foreignLanguages
            .toLowerCase()
            .includes(this.searchInput.toLowerCase().trim())
        ) {
          return true;
        }
      }
      return false;
    },
    search() {
      this.contactResults = [];
      this.productResults = [];
      this.searchProducts();
      this.searchContacts();
    },
    goToProduct(p) {
      this.$router.push({ path: `/products/${p.category}/${p.url}` });
      this.closeSearch();
    },
    selectProfile(profile) {
      this.selectedProfile = profile;
    },
    closeSearch() {
      this.$eventHub.$emit("search-closed");
      this.searchInput = "";
      this.contactResults = [];
      this.productResults = [];
    }
    // scrollMovement(e) {
    //   if (this.contactResults.length || this.productResults.length) {
    //     if (e.deltaY > 0) {
    //       // downwards
    //       if (
    //         this.scrollResults * -1 <
    //         this.$refs.results.offsetHeight -
    //           this.$refs.resultsWrapper.offsetHeight
    //       ) {
    //         this.scrollResults -=
    //           (this.$refs.results.offsetHeight -
    //             this.$refs.resultsWrapper.offsetHeight) /
    //           50;
    //         this.scrollPosition += this.$refs.scrollbar.offsetHeight / 50;
    //       } else {
    //         // this.scrollResults = this.$refs.results.offsetHeight - this.$refs.resultsWrapper.offsetHeight;
    //         this.scrollPosition = this.$refs.scrollbar.offsetHeight - 20;
    //       }
    //     } else if (e.deltaY < 0) {
    //       // upwards
    //       if (this.scrollResults < 0) {
    //         this.scrollResults +=
    //           (this.$refs.results.offsetHeight -
    //             this.$refs.resultsWrapper.offsetHeight) /
    //           50;
    //         this.scrollPosition -= this.$refs.scrollbar.offsetHeight / 50;
    //       } else {
    //         this.scrollResults = 0;
    //         this.scrollPosition = 0;
    //       }
    //     }
    //   }
    // }
  },
  mounted() {
    document.body.classList.add("stop-scrolling");
    this.$eventHub.$on("close-profile", () => {
      this.selectedProfile = undefined;
    });
    this.$refs.searchInputField.focus();
    // document.addEventListener("wheel", this.scrollMovement);
  },
  destroyed() {
    document.body.classList.remove("stop-scrolling");
    // document.removeEventListener("wheel", this.scrollMovement);
    this.$eventHub.$off("close-profile");
  }
};
</script>

<style scoped>
.mobile-search-close {
  display: none;
}
.search-wrapper {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  left: 0;
  padding: 30px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 3;
}
.search-close {
  align-items: center;
  color: #cecece;
  cursor: pointer;
  display: flex;
  font-size: 24px;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 20px;
  top: 20px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 40px;
}
.search-close:hover {
  color: #fff;
  background-color: #cecece;
}
.search-input-wrapper {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 600px;
}
.search-input {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #00305b;
  caret-color: #7992a9;
  color: #00305b;
  font-size: 58px;
  margin-bottom: 10px;
  padding-bottom: 5px;
  text-align: center;
  width: 100%;
}
.search-input::-moz-placeholder {
  color: rgba(0, 48, 91, 0.5);
  opacity: 0.5;
}
.search-input:-moz-placeholder {
  color: rgba(0, 48, 91, 0.5);
  opacity: 0.5;
}
.search-input::-webkit-input-placeholder {
  color: rgba(0, 48, 91, 0.5);
  opacity: 0.5;
}
.search-input:-ms-input-placeholder {
  color: rgba(0, 48, 91, 0.5);
  opacity: 0.5;
}
.search-text {
  color: #00305b;
  font-size: 16px;
  font-weight: 500;
}
.text-light {
  color: #a2abb8;
}
.search-zoom {
  color: rgba(206, 206, 206, 0.5);
  font-size: 200px;
  margin-top: 80px;
}
/* RESULTS */
.search-results {
  display: flex;
  flex-wrap: wrap;
  margin-top: 40px;
  max-height: 70vh;
  /* overflow: hidden; */
  overflow: auto;
  position: relative;
  width: 990px;
}
/* .search-scrollable-results {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
} */
.search-result {
  align-items: center;
  background-color: #fff;
  -webkit-box-shadow: 0px 0px 60px -30px rgba(0, 48, 91, 1);
  -moz-box-shadow: 0px 0px 60px -30px rgba(0, 48, 91, 1);
  box-shadow: 0px 0px 60px -30px rgba(0, 48, 91, 1);
  cursor: pointer;
  display: flex;
  height: 124px;
  margin: 10px;
  max-width: calc(33.33% - 20px);
  min-width: calc(33.33% - 20px);
  padding: 10px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.search-result-img {
  background-size: cover;
  border-radius: 50%;
  height: 65px;
  margin-right: 10px;
  min-height: 65px;
  min-width: 65px;
  width: 65px;
}
.search-result-icon {
  align-items: center;
  background-color: #f1f4f8;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  height: 65px;
  margin-right: 10px;
  min-height: 65px;
  min-width: 65px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 65px;
}
.search-result-icon span {
  font-size: 24px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.search-result h6 {
  font-size: 20px;
  margin: 5px 0;
}
.search-result p {
  color: #9fa8b5;
  font-size: 12px;
}
.search-result:hover {
  background-color: #f8f9fb;
}
.search-result:hover .search-result-icon {
  background-color: #00305b;
}
.search-result:hover .search-result-icon span {
  color: #fff;
}
/* .search-scrollbar {
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
}
.search-scrollline {
  background-color: #f1f4f8;
  height: 100%;
  position: absolute;
  right: 2px;
  top: 0;
  width: 2px;
}
.search-scroll {
  background-color: #00305b;
  cursor: pointer;
  height: 20px;
  width: 6px;
  position: absolute;
  top: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  right: 0;
} */
@media screen and (max-width: 1000px) {
  .search-close {
    display: none;
  }
  .mobile-search-close {
    align-items: center;
    background: #fff;
    background-color: #fff;
    border: 1px solid #004785;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 50px;
    justify-content: center;
    right: 20px;
    position: absolute;
    top: 20px;
    width: 50px;
  }
  .mobile-search-close-inside {
    align-items: center;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#2ea5d8+0,004786+15,004786+24,2ea5d8+40,2593c8+50,0e639e+65,004786+75,004786+85,2ea5d8+100 */
    background: rgb(46, 165, 216); /* Old browsers */
    background: -moz-linear-gradient(
      left,
      rgba(46, 165, 216, 1) 0%,
      rgba(0, 71, 134, 1) 15%,
      rgba(0, 71, 134, 1) 24%,
      rgba(46, 165, 216, 1) 40%,
      rgba(37, 147, 200, 1) 50%,
      rgba(14, 99, 158, 1) 65%,
      rgba(0, 71, 134, 1) 75%,
      rgba(0, 71, 134, 1) 85%,
      rgba(46, 165, 216, 1) 100%
    ); /* FF3.6-15 */
    background: -webkit-linear-gradient(
      left,
      rgba(46, 165, 216, 1) 0%,
      rgba(0, 71, 134, 1) 15%,
      rgba(0, 71, 134, 1) 24%,
      rgba(46, 165, 216, 1) 40%,
      rgba(37, 147, 200, 1) 50%,
      rgba(14, 99, 158, 1) 65%,
      rgba(0, 71, 134, 1) 75%,
      rgba(0, 71, 134, 1) 85%,
      rgba(46, 165, 216, 1) 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
      to right,
      rgba(46, 165, 216, 1) 0%,
      rgba(0, 71, 134, 1) 15%,
      rgba(0, 71, 134, 1) 24%,
      rgba(46, 165, 216, 1) 40%,
      rgba(37, 147, 200, 1) 50%,
      rgba(14, 99, 158, 1) 65%,
      rgba(0, 71, 134, 1) 75%,
      rgba(0, 71, 134, 1) 85%,
      rgba(46, 165, 216, 1) 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2ea5d8', endColorstr='#2ea5d8',GradientType=1 ); /* IE6-9 */
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    height: 42px;
    justify-content: center;
    overflow: hidden;
    position: relative;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    width: 42px;
  }
  .mobile-search-close-line {
    background-color: #fff;
    display: inline-block;
    width: 18px;
    height: 2px;
    margin: 2px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }

  .mobile-search-close-line:first-child {
    background-color: #fff;
    margin: -1px;
    transform: rotate(45deg);
  }
  .mobile-search-close-line:last-child {
    background-color: #fff;
    margin: -1px;
    transform: rotate(-45deg);
  }
  .search-input-wrapper {
    width: 100%;
  }
  .search-input {
    font-size: 29px;
  }
  .search-text {
    font-size: 12px;
  }
  .search-zoom {
    font-size: 50px;
    margin-top: 10px;
  }
  .search-results {
    width: 100%;
  }
  .search-result {
    max-width: calc(50% - 20px);
    margin: 10px;
    min-width: calc(50% - 20px);
    width: calc(50% - 20px);
  }
}
@media screen and (max-width: 600px) {
  .search-results {
    width: 320px;
  }
  .search-result {
    max-width: 100%;
    margin: 7.5px 0;
    min-width: 100%;
    width: 100%;
  }
}
@media screen and (max-width: 440px) {
  .mobile-search-close {
    height: 40px;
    top: 25px;
    width: 40px;
  }
  .mobile-search-close-inside {
    height: 32px;
    width: 32px;
  }
  .mobile-search-close-line {
    width: 14px;
  }
  .search-input {
    font-size: 22px;
  }
}
@media screen and (max-width: 420px) {
  .search-results {
    width: 100%;
  }
  .search-result h6 {
    font-size: 16px;
  }
  .search-result p {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Search.vue